//#region import
import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { Button, Divider, Grid, Typography } from '@mui/material';
import { FnAxios, FnDialog, I18n, RouterDOM } from 'utilities/utilities';
import { APIStatusCode, I18NextNs } from 'enum/enum';
import { ApiApplyMember } from 'enum/api';
import OtpInput from 'react-otp-input';
import CachedIcon from '@mui/icons-material/Cached';
import { BtnCancelForm, BtnSave } from 'components/Button/ButtonAll';
import "./OTP.css";
//#endregion

interface IEmailOTP {
    setisOpen?: (value: boolean) => void;
    ObjEmailOTP?: {
        sEmail: string;
        nUserID: number;
        sPWDOTP: string;
        IsApplyMember: boolean;
    };
}

const EmailOTP = (props: IEmailOTP) => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const Router = RouterDOM();

    const nSecond = 300;
    const [IsApplyMember, setIsApplyMember] = useState(props.ObjEmailOTP?.IsApplyMember ?? null); //mode > 1 = Login == False / 2 = ApplyMember == True
    const [IsEmailOTP, setIsEmailOTP] = useState(false); //True = มาจากลิงค์ Email | False = จากหน้าเว็บ

    const [sUserID, setsUserID] = useState(null);
    const [nUserID, setnUserID] = useState(props.ObjEmailOTP?.nUserID ?? null);
    const [sEmail, setsEmail] = useState(props.ObjEmailOTP?.sEmail ?? null);
    const [sPWDOTP, setsPWDOTP] = useState(props.ObjEmailOTP?.sPWDOTP ?? null);
    const [sOTP, setsOTP] = useState(null);

    //#region นับเวลา
    // const [loading, setLoading] = React.useState(false);    
    // useCountUp({ 
    //     ref: 'counter', 
    //     start: 120, 
    //     end: 0, 
    //     duration: 2.75, 
    //     delay: 2, 
    // });
    // const containerProps = {'aria-busy': loading,};

    const [sCountDownTime, setsCountDownTime] = useState(null);
    useEffect(() => {
        if (sCountDownTime === 0) {
           //// console.log("TIME LEFT IS 0");
           setsCountDownTime(null);
           handleCancelOTP(false);
        }

        // exit early when we reach 0
        if (!sCountDownTime) return;

        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
            setsCountDownTime(sCountDownTime - 1);
        }, 1000);

        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
    }, [sCountDownTime]);
    //#endregion

    useEffect(() => {
        let params = new URLSearchParams(window.location.search)
        if (params.size !== 0) {
            let sUserID_ = params.get('strid');
            let sMode_ = params.get('mode');
            setsUserID(sUserID_);
            setIsApplyMember(sMode_ === "2"); //mode > 1 = Login == False / 2 = ApplyMember == True
            setIsEmailOTP(true);
            handleGetFormOTP(sUserID_);
        } else {
            setsCountDownTime(nSecond);
        }
    }, []);

    const handleGetFormOTP = (sUserID_) => {
        DialogFn.BlockUI();
        let oParam = {
            nUserID: nUserID,
            sEmail: sEmail,
            sPWDOTP: sPWDOTP,
            sUserID: sUserID_,
            IsApplyMember: IsApplyMember,
        };
        AxiosFn.Post(ApiApplyMember.GetFormOTP, oParam, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === APIStatusCode.Success) {
                if (result.objResult) {
                    setnUserID(result.objResult.nUserID);
                    setsEmail(result.objResult.sEmail);
                    setsPWDOTP(result.objResult.sPWDOTP);
                    //// console.log("GetFormOTP > result.objResult", result.objResult);                    
                }
                setsCountDownTime(nSecond);
            } else if (result.nStatusCode === APIStatusCode.Warning) {
                DialogFn.Warning(result.sMessage);
            }
        },
            (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
    };

    const handleChangeOTP = () => {
        DialogFn.BlockUI();
        let oParam = {
            nUserID: nUserID,
            sEmail: sEmail,
            sPWDOTP: sPWDOTP,
            sUserID: sUserID,
            IsApplyMember: IsApplyMember,
        };
        AxiosFn.Post(ApiApplyMember.ChangeOTP, oParam, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === APIStatusCode.Success) {
                DialogFn.Success(I18n.SetText("msgOTP"));
                DialogFn.CloseSubmit();
                setsCountDownTime(nSecond);
                setsPWDOTP(result.objResult.sPWDOTP);
                //// console.log("ChangeOTP > result.objResult", result.objResult);   
            } else if (result.nStatusCode === APIStatusCode.Warning) {
                DialogFn.Warning(I18n.SetText("AlertError"));
                setsCountDownTime(0);
            }
        },
            (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
    };

    const handleCancelOTP = (isCancel) => {     
        let oParam = {
            nUserID: nUserID,
            sEmail: sEmail,
            sPWDOTP: sPWDOTP,
            sUserID: sUserID,
            IsApplyMember: IsApplyMember,
        };
        AxiosFn.Post(ApiApplyMember.CancelOTP, oParam, (result) => {
            if (result.nStatusCode === APIStatusCode.Success) {
                if (IsEmailOTP) {
                    Router.GoToPage("/Home");
                } else if (isCancel) { 
                    handleSetOpen();
                } else {
                    DialogFn.Warning(I18n.SetText("msgOTPWarning"));
                }
            } else if (result.nStatusCode === APIStatusCode.Warning) {
                DialogFn.Warning(I18n.SetText("AlertError"));
            }
        },
            (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
    };

    const handleSetOpen = () => {
        if (props.setisOpen) props.setisOpen(false);
    }

    const handleSubmit = () => {
        //// console.log("handleSubmit OTP > sPWDOTP", sPWDOTP);  
        //// console.log("handleSubmit OTP > sOTP", sOTP);
        
        if (sOTP !== sPWDOTP) {
            DialogFn.Warning(I18n.SetText("msgOTPError"));
        }
        else if (sOTP === sPWDOTP && (sCountDownTime === null || sCountDownTime === 0)) {
            DialogFn.Warning(I18n.SetText("msgOTPWarning"));
        }
        else {
            let ObjParam = {
                nUserID: nUserID,
                IsApplyMember: IsApplyMember,
            };
            DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
                DialogFn.BlockUI();
                AxiosFn.Post(ApiApplyMember.ChangeSecuredCodeOTP, ObjParam, (result) => {
                    DialogFn.UnBlockUI();
                    if (result.nStatusCode === APIStatusCode.Success) {
                        DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent));
                        DialogFn.CloseSubmit();
                        if (IsEmailOTP || IsApplyMember === true) { 
                            Router.GoToPage("/Home");
                        } else { 
                            handleSetOpen();
                        }
                    } else if (result.nStatusCode === APIStatusCode.Warning) {
                        //// DialogFn.Warning(I18n.SetText("AlertError"));
                        DialogFn.Warning(result.sMessage);
                    }
                },
                    (err) => {
                        DialogFn.UnBlockUI();
                        if (!err.response) {
                            DialogFn.Warning(err.sMessage);
                        }
                    });
            });
        }
    };

    const CountTime = useMemo(() => {
        return (
            <Grid item>
                <Typography color={'red'}>
                    {sCountDownTime ?? 0}
                </Typography>
            </Grid>
        );
    }, [sCountDownTime]);
    
    return (
        <Fragment>
            <Grid item container xs={12} md={12} justifyContent={"center"} alignItems={"center"} alignContent={"center"} className='bgOTP'>
                <Grid item xs={12} md={5} container spacing={1} justifyContent={"center"} alignItems={"flex-start"} alignContent={"flex-start"} className='cOTP'>         
                    <Grid item xs={12} md={12} container justifyContent={"start"}>
                        <Grid item xs={12} md={12} container justifyContent={"start"}>
                            {/* ยืนยันตัวตนผ่าน OTP */}
                            <Grid item xs={10} md={10}>
                                <Typography variant='h6' color={'black'} gutterBottom >{I18n.SetText("OTP")}</Typography>
                            </Grid>
                            {/* <Grid item xs={2} md={2} container justifyContent={"end"}>
                                <Tooltip title={I18n.SetText("close")} placement="right" arrow style={{ zIndex: 100000}}>
                                    <div onClick={() => { props.setisOpen && props.setisOpen(false); }} >
                                        <Close 
                                            fontSize='large' 
                                            className='m-[auto] text-[white] cClose'
                                        />
                                    </div>
                                </Tooltip>
                            </Grid> */}
                        </Grid>
                        <Grid item xs={12} md={12}><Divider /></Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {/* รหัส OTP ได้ถูกส่งไปยังอีเมล xxxxxx@co.th กรุณาใส่รหัส OTP ที่ท่านได้รับ */}
                        {/* <Typography color={'black'} gutterBottom >{ParseHtml(I18n.SetText("OTPEmail")+"")}</Typography> */}

                        {/* รหัส OTP ได้ถูกส่งไปยังอีเมล xxxxxx@co.th */}
                        <Typography color={'black'} gutterBottom >{I18n.SetText("OTPEmailUser") + (sEmail ?? "xxxxxx@co.th")}</Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {/* กรุณาใส่รหัส OTP ที่ท่านได้รับ */}
                        <Typography color={'black'} gutterBottom >{I18n.SetText("OTPEmail")}</Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {/* กรุณาไม่ปิดหน้าจอ จนกว่าจะดำเนินการเสร็จสิ้น */}
                        <Typography color={'red'} >{I18n.SetText("OTPClose")}</Typography>
                    </Grid>
                    <Grid item xs={12} md={5} container justifyContent={"center"} alignItems={"flex-start"} alignContent={"flex-start"}>
                        <OtpInput
                            value={sOTP}
                            onChange={setsOTP}
                            numInputs={6}
                            inputType={'number'}
                            inputStyle={{
                                // width: '1rem !important',
                                width: '50px',
                                height: '2.5rem',
                                margin: '0 1rem',
                                fontSize: '1.5rem',
                                borderRadius: '4px',
                                border: '1px solid rgba(0,0,0,.3)',
                            }}
                            renderSeparator={<span className='cOtpInput'>-</span>}
                            renderInput={(props) => <input {...props} />}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} justifyContent={"center"} alignItems={"flex-start"} alignContent={"flex-start"}>
                        {/* เหลือเวลาอีก 120 วินาที */}

                        {/* เหลือเวลาอีก */}
                        <Grid item><Typography color={'red'} >{I18n.SetText("OTPStillTime")}</Typography></Grid>
                        {/* นับเวลา */}
                        {CountTime}
                        {/* <Grid item>
                            <Typography color={'red'}>
                                ////  CountUp 
                                ////         start={120} 
                                ////         end={0} 
                                ////         delay={2} 
                                ////         duration={2.75}
                                ////         containerProps={containerProps} 
                                ////         style={{ color: 'red' }} 
                                ////     />
                                {sCountDownTime ?? 0}
                            </Typography>
                        </Grid> */}
                        {/* วินาที */}
                        <Grid item><Typography color={'red'}>{I18n.SetText("OTPSecond")}</Typography></Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {/* ขอรหัส OTP ใหม่อีกครั้ง */}
                        <Button variant="text" startIcon={<CachedIcon style={{ fontSize: 'xx-large', }} />} className='cOTPNew' onClick={() => { handleChangeOTP(); }}><Typography color={'#1976d2'} >{I18n.SetText("OTPNew")}</Typography></Button>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} justifyContent={"end"} alignItems={"flex-start"} alignContent={"flex-start"}>
                        <Grid item>
                            <BtnSave id={"BtnSave"} txt={I18n.SetText("OTPSave")} onClick={handleSubmit} />
                        </Grid>
                        <Grid item>
                            <BtnCancelForm id={"BtnBack"} onClick={()=> { handleCancelOTP(true); }} />
                        </Grid>           
                    </Grid>
                </Grid>
            </Grid>
        </Fragment>
    )
}
export default EmailOTP;
